<template>
    <dv-scroll-board :config="config" style="width:100%;height:100%;" />
  </template>
  
  <script>
  //专区排行
  export default {
    name: "AirList",
    data() {
      return {
        config: {},
      }
    },
    methods:{
  
    },
    created() {
  
       let data=[];
       data[0]=['2025-04-07','32℃','18%'];
       data[1]=['2025-04-08','23℃','22%'];
       data[2]=['2025-04-09','23℃','22%'];
       data[3]=['2025-04-09','25℃','20%'];
       data[4]=['2025-04-10','24℃','20%'];
       data[5]=['2025-04-11','25℃','19%'];
  
        this.config = {
          header: ['日期', '温度', '湿度'],
          rowNum:[4],
          data: data,
          headerBGC: '#0081EE',
          oddRowBGC: '#0e0e26',
          evenRowBGC: '#0e0e26',
          index: true,
          columnWidth: [50,320],
          align: ['center']
        }
  
  
    },
  
    watch: {
  
    }
  }
  </script>
  
  <style scoped>
  
  </style>